import { useInfiniteQuery } from "@tanstack/react-query";
import getOrganizationProfiles from "../axios/getOrganizationProfiles";

const useQueryOrganizationProfiles = () => {
  return useInfiniteQuery(
    ["organisasi_internasional"],
    ({ pageParam = 1 }) => {
      return getOrganizationProfiles({ page: pageParam });
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        const organizationProfilesList = allPages.flatMap(
          (page) => page.organisasi_internasional.data,
        );
        if (
          organizationProfilesList.length <
          lastPage.organisasi_internasional.total
        ) {
          return lastPage.organisasi_internasional.current_page + 1;
        }
        return undefined;
      },
    },
  );
};

export default useQueryOrganizationProfiles;
